module.exports = __webpack_public_path__ + "img/Speaker=Chander Subramaniam.9720f0a8.png";